import { render, staticRenderFns } from "./SearchCopyDoctor.vue?vue&type=template&id=75f75ae3&scoped=true"
import script from "./SearchCopyDoctor.vue?vue&type=script&lang=js"
export * from "./SearchCopyDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f75ae3",
  null
  
)

export default component.exports